import React from "react";
import logo from "../../assets/logo.png";
import rongkeLogo from "../../assets/rongkeLogo.png";
import castingPng from '../../assets/投屏.png';
import "./styles.css";

type IProps = { rongkeTag: boolean };

export const Header: React.FC<IProps> = (props) => {
  const { rongkeTag } = props;
  const toPortal = () => {
    window.open(
      rongkeTag
        ? `https://${window.location.host}/school/w/portal/#/login`
        : `https://${window.location.host}/school/ecloud/portal/#/login`
    );
  };

  const goHelp = () => {
    window.open(
      "https://rongke-plaso.feishu.cn/wiki/space/7273301469393436700?ccm_open_type=lark_wiki_spaceLink"
    );
  };

  const toCasting = () => {
    window.open(
      `https://${window.location.host}/school/w/board/#/casting`
    );
  };
  return (
    <div className="header">
      <div className="content">
        <div className="headerleft">
          <img
            src={rongkeTag ? rongkeLogo : logo}
            className="logo"
            width="200"
            height="40"
          />
        </div>
        <div className="topRight">
          <a className="jumpLink" onClick={toCasting}>
            <img src={castingPng} alt="画布投屏" style={{ height: '18px', marginRight: '8px' }} /> 画布投屏
          </a>
          <a className="jumpLink" onClick={toPortal}>
            登录
          </a>
          {rongkeTag && (
            <a className="jumpLink" onClick={goHelp}>
              帮助中心
            </a>
          )}
        </div>
      </div>
    </div>
  );
};
